import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { User, LogOut, LayoutDashboard } from 'lucide-react';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="navbar-professional sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <img 
              src="https://shortstayx.com/wp-content/uploads/2025/12/Untitled-3-e1765881709572.webp" 
              alt="ShortStayX Logo" 
              className="h-14 w-auto"
            />
          </Link>
          
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="font-medium transition-colors hover:text-[#d4a574]" style={{ color: '#2d3436' }}>
              Home
            </Link>
            <Link to="/properties" className="font-medium transition-colors hover:text-[#d4a574]" style={{ color: '#2d3436' }}>
              Properties
            </Link>
            
            {user ? (
              <>
                {user.role === 'admin' && (
                  <Link to="/super-admin">
                    <Button className="btn-primary-custom rounded-full px-6 flex items-center gap-2">
                      <LayoutDashboard size={18} />
                      Admin Panel
                    </Button>
                  </Link>
                )}
                {user.role === 'landlord' && (
                  <Link to="/landlord/dashboard">
                    <Button className="btn-primary-custom rounded-full px-6 flex items-center gap-2">
                      <LayoutDashboard size={18} />
                      My Properties
                    </Button>
                  </Link>
                )}
                {user.role === 'client' && (
                  <Link to="/client/dashboard">
                    <Button className="btn-primary-custom rounded-full px-6 flex items-center gap-2">
                      <User size={18} />
                      My Bids
                    </Button>
                  </Link>
                )}
                <Button 
                  onClick={handleLogout}
                  variant="outline"
                  className="rounded-full px-6 flex items-center gap-2"
                  style={{ borderColor: '#d4a574', color: '#d4a574' }}
                >
                  <LogOut size={18} />
                  Logout
                </Button>
              </>
            ) : (
              <>
                <Link to="/login">
                  <Button variant="outline" className="rounded-full px-6" style={{ borderColor: '#d4a574', color: '#d4a574' }}>
                    Login
                  </Button>
                </Link>
                <Link to="/register">
                  <Button data-testid="enquire-nav-button" className="btn-primary-custom rounded-full px-6">
                    Register
                  </Button>
                </Link>
              </>
            )}
          </div>
          
          <div className="md:hidden">
            {user ? (
              <Button 
                onClick={handleLogout}
                size="sm" 
                variant="outline"
                className="rounded-full"
              >
                Logout
              </Button>
            ) : (
              <Link to="/login">
                <Button data-testid="enquire-mobile-button" size="sm" className="btn-primary-custom rounded-full">
                  Login
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;